<script>
import { reactive } from "vue";
import { Head, Link, router } from '@inertiajs/vue3';
import BreezeLayout from '@/Layouts/Authenticated.vue';
import BreezeButton from '@/Components/Button.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';

export default {
    components: {
        BreezeLayout,
        BreezeButton,
        BreezeInput,
        BreezeLabel,
        Head,
        Link
    },
    props: {
        brand_slugs: Object,
        all_roles: Object,
    },
    setup(props) {
        console.log(props);
        const form = reactive({
            name: null,
            password: null,
            email: null,
            account_holder_code: null,
            second_account_holder_code: null,
            client: null,
            brand_slug: null,
            roles: [],
        });

        const update = () => {
            router.post(route('users.store'), form);
        };

        return {
            form,
            update
        };
    },
}
</script>

<template>
    <Head title="Create user"/>

    <BreezeLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight flex">
                <Link :href="route('users.index')">Users</Link>
            </h2>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-gray-100">
                    <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                        <div class="mt-10 sm:mt-0">
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1 flex justify-between flex-col">
                                    <div class="px-4 sm:px-0">
                                        <h3 class="text-lg font-medium leading-6 text-gray-900">Create User</h3>
                                        <p class="mt-1 text-sm text-gray-600">

                                        </p>
                                    </div>
                                    <div class="pb-2">
                                        <Link :href="route('users.index')" class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-slate-400 hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-600">← BACK</Link>
                                    </div>
                                </div>
                                <div class="mt-5 md:mt-0 md:col-span-2">
                                    <form @submit.prevent="update">
                                        <div class="shadow overflow-hidden sm:rounded-md">
                                            <div class="px-4 py-5 bg-white sm:p-6 relative">
                                                <table class="table-auto w-3/4">
                                                    <caption class="hidden">User creation</caption>

                                                    <tr>
                                                        <th class="text-left py-2">Fields</th>
                                                        <th class="text-left py-2">Values</th>
                                                    </tr>

                                                    <tr>
                                                        <td class="pr-5 py-2">Username*</td>
                                                        <td class="py-2">
                                                            <BreezeInput
                                                                id="name"
                                                                type="text"
                                                                v-model="form.name"
                                                                required />
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td class="pr-5 py-2">Password*</td>
                                                        <td class="py-2">
                                                            <BreezeInput
                                                                id="password"
                                                                type="password"
                                                                v-model="form.password"
                                                                required />
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td class="pr-5 py-2">Email*</td>
                                                        <td class="py-2">
                                                            <BreezeInput
                                                                id="email"
                                                                type="email"
                                                                v-model="form.email"
                                                                required />
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td class="pr-5 py-2 text-nowrap">Account Holder Code</td>
                                                        <td class="py-2">
                                                            <BreezeInput
                                                                id="account_holder_code"
                                                                type="text"
                                                                v-model="form.account_holder_code"
                                                            />
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td class="pr-5 py-2">Second Account Holder Code</td>
                                                        <td class="py-2">
                                                            <BreezeInput
                                                                id="second_account_holder_code"
                                                                type="text"
                                                                v-model="form.second_account_holder_code"
                                                            />
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td class="pr-5 py-2">Brand*</td>
                                                        <td class="py-2">
                                                            <select v-model="form.brand_slug" id="brand_slug" name="brand_slug"
                                                                class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" required>
                                                                <option v-for="brand_slug in brand_slugs" v-bind:value="brand_slug.brand_slug">
                                                                    {{ brand_slug.brand_slug }}
                                                                </option>
                                                            </select>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td class="pr-5 py-2">Role</td>
                                                        <td class="py-2">
                                                            <div class="mt-1">
                                                                <div v-for="role in all_roles" :key="role" class="flex items-center mb-2">
                                                                    <input
                                                                        type="checkbox"
                                                                        :id="role"
                                                                        :value="role"
                                                                        v-model="form.roles"
                                                                        class="mr-2 border-gray-300 rounded focus:ring-indigo-500 hover:cursor-pointer"
                                                                    />
                                                                    <label :for="role" class="hover:cursor-pointer">{{ role }}</label>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>

                                                </table>
                                            </div>
                                            <div class="flex justify-end px-4 py-3 bg-gray-50 text-right sm:px-6">
                                                <BreezeButton
                                                    class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                    :class="{ 'opacity-25': form.processing }"
                                                    :disabled="form.processing">
                                                    Create user
                                                </BreezeButton>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </BreezeLayout>
</template>
